import Autocomplete from 'react-autocomplete';
import React from 'react';
import './Autocomplete.css';

const WrappedAutocomplete = props => (
	<Autocomplete
		wrapperProps={{className: 'Autocomplete'}}
		renderItem={(item, isHighlighted) => (
			<div
				className={`Autocomplete-item ${isHighlighted ? 'highlighted' : ''}`}
				key={item.value || item.label}
			>{item.label}</div>
		)}
		renderMenu={(items, value, style) => (
			<div style={style} className="Autocomplete-menu" children={items} />
		)}
		getItemValue={item => item.value || item.label}
		{...props}
	/>
);

export default WrappedAutocomplete;


// WEBPACK FOOTER //
// ./src/widgets/Autocomplete.js